<template>
  <div>
    <div ref="payRemindChart" class="chart"></div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  name: "",
  props: {
    // trendingList: {
    //   type: Array,
    //   default: ()=> []
    // }
    seriesData: {
      type: Array,
      default: () => [],
    },
    echartsDate: {
      type: Array,
      default: () => [],
    },
    legendShow: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    seriesData(nVal, oVal) {
      this.initData();
    },
  },
  data() {
    return {
      myCharts: null,
      date: [],
      seriesList: [],
      nameList: [],
      lineColors: [
        "#7F85E9",
        "#FE4D45",
        "#4878FF",
        "#49C568",
        "#00FF00",
        "	#FF7F50",
        "	#FA8072",
        "#8B0000",
      ],
      areaColors: [
        "rgba(127, 133, 233, 0.2)",
        "rgba(30,144,255,0.2)",
        "rgba(0,191,255,0.2)",
        "rgba(64,224,208,0.2)",
        "rgba(0,255,0,0.2)",
        "rgba(255,127,80,0.2)",
        "rgba(250,128,114,0.2)",
        "rgba(139,0,0,0.2)",
      ],
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      var seriesList = [];
      var nameList = [];
      this.seriesData.forEach((item, index) => {
        var lineColor = this.lineColors[index % 7];
        var areaColor = this.areaColors[index % 7];
        var temp = {
          name: item.name,
          smooth: true,
          type: "line",
          itemStyle: {
            //折线拐点标志的样式。
            normal: {
              //默认样式
              color: lineColor,
              lineStyle: {
                //线条样式
                // color: '#3888fa',
                width: 2,
              },
              areaStyle: {
                //区域填充样式
                color: areaColor,
              },
            },
          },
          data: item.data, //数据
          animationDuration: 2800, //初始动画时长
          animationEasing: "quadraticOut", //初始动画的缓动效果。
        };
        seriesList.push(temp);
        nameList.push(item.name);
      });
      this.seriesList = seriesList;
      this.nameList = nameList;

      this.$nextTick(() => {
        this.initChart();
        window.addEventListener("resize", () => {
          this.myCharts.resize();
        });
      });
    },

    initChart() {
      this.myCharts = echarts.init(this.$refs.payRemindChart);
      this.setOptions();
    },
    setOptions() {
      let options = {
        // x轴配置
        xAxis: {
          data: this.echartsDate,
          boundaryGap: false,
          axisTick: {
            show: false,
          },
        },

        // 直角坐标系内绘图网格
        grid: {
          left: 10,
          right: 40,
          bottom: 30,
          top: 30,
          containLabel: true, //grid 区域是否包含坐标轴的刻度标签。
        },
        // 提示框组件
        tooltip: {
          trigger: "axis", //坐标轴触发
          axisPointer: {
            //指示器类型
            type: "cross",
          },
          padding: [5, 10],
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
        // y轴配置
        yAxis: {
           axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
           
            lineStyle:{
              color: '#eee',
            }
          },
        },
        // 图例
        legend: {
          // data: ["成交客户数", "成交订单数", "成交金额"],
          data: this.nameList,
          bottom: 0,
          // left: 50,
          show: this.legendShow
        },
        // 系列列表。每个系列通过 type 决定自己的图表类型
        series: this.seriesList,
      };
      this.myCharts.setOption(options);
    },
  },
};
</script>

<style lang="scss" scoped>
.chart {
  height: 300px;
}
</style>